import {get} from './request';
import {always, applySpec, applyTo, compose, constructN, defaultTo, identity, prop,} from 'ramda';

/** @typedef { import('axios').AxiosRequestConfig } AxiosRequestConfig */

const getURLSearchParams = constructN(1, URLSearchParams);
const results = prop('results');
const suggestions = prop('suggestions');
const emptyArray = defaultTo([]);

/**
 * @typedef NameSuggestion
 * @property {string} value
 * @property {object} data
 * @property {string} data.name
 * @property {string} data.surname
 * @property {string} data.patronymic
 * @property {'FEMALE'|'MALE'|'UNKNOWN'} data.gender
 * @property {'1'|'0'} qc
 */

/**
 * Get Dadata name suggestions by query
 *
 * @param {string} query Search query
 * @param {AxiosRequestConfig?} config Optional axios configuration
 * @returns {Promise<NameSuggestion[]>} Array of Dadata name suggestions
 */
export const getFullNameSuggestions = (query, config) =>
    get(
        '/api/Dadata/get/',
        config,
        applyTo(query, compose(
            getURLSearchParams,
            applySpec({
                type: always('fio'),
                query: identity,
            })
        ))
    )
        .then(suggestions)
        .catch(emptyArray);

/**
 * @typedef {object} AddressSuggestion
 * @property {string} value
 * @property {string} unrestricted_value
 */

/**
 * Get Dadata address suggestions by query
 *
 * @param {string} query Search query
 * @param {AxiosRequestConfig?} config Optional axios configuration
 * @returns {Promise<AddressSuggestion[]>} Array of Dadata address suggestions
 */
export const getAddressSuggestions = (query, config) =>
    get(
        '/api/Location/getCities/',
        config,
        applyTo(query, compose(
            getURLSearchParams,
            applySpec({
                _type: always('query'),
                term: identity,
                q: identity,
            })
        ))
    )
        .then(results)
        .catch(emptyArray);
